import { IsNumber, IsOptional, IsString } from 'class-validator'

export type IMensajeRecibo = {
  id: number | null
  aplicacionId: number
  tipoMensajeId: number
  mensaje: JSON
  eliminado: boolean
}

export type ITipoMensaje = {
  id: number | null
  nombre: string
  configuracion: JSON
  eliminado: boolean
}

export type IAplicacion = {
  id: number | null
  tipoAplicacionId: number
  nombre: string
  identificador: string
  identificadorPadre: string | null
  dominio: string
  usuarioCaptura: string
  apiKey: string
  accessToken: string
  redirect: string
  capturaFecha: Date
  token: string
}
export class SistemaMensajeria {
  @IsNumber()
  plataformaId!: number

  @IsString()
  nombre!: string

  @IsString()
  identificador!: string

  @IsString()
  dominio!: string

  @IsOptional()
  @IsString()
  token?: string

  @IsOptional()
  nuevoIdentificador?: string
}
